import UserManagement from './user_management.vue';

export default UserManagement;
